import wireframes, { wireframeNameToClass } from '../wireframes';
import Stylus from './Stylus';
import WireframeDrawingBrush from './WireframeDrawingBrush';
import styles from '../styles.module.css';
import { labeledMenuComponent } from '../utils/stylus';

// Create new wireframe objects.
class StylusWireframe extends Stylus {
  wireframeName: string;
  wireframeClass: any;

  constructor({ controller, wireframeName }) {
    super({ controller });
    this.wireframeName = wireframeName;
    this.wireframeClass = wireframes.wireframeNameToClass(this.wireframeName);
  }

  stylusId() {
    return this.wireframeName;
  }

  activate() {
    const brush = new WireframeDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  renderIcon() {
    return this.wireframeClass.renderIcon();
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  cursor() {
    return 'crosshair';
  }

  wireframeNameToDescription(wireframeName: string) {
    const wireframeClass = wireframeNameToClass(wireframeName);

    return wireframeClass.externalName();
  }

  description() {
    return this.wireframeNameToDescription(this.wireframeName);
  }

  subMenuIncludes(wireframeName: string) {
    return this.controller.allWireframes.includes(wireframeName);
  }
}

export default StylusWireframe;
